export const errormessages = {
  NO_NEXT_ARTICLE: "다음 글이 없습니다.",
  NO_PREVIOUS_ARTICLE: "이전 글이 없습니다.",
};
